<div>
  <div class="container-fluid bg-white p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="Seriti Finance Application" />
    <div v-if="data_ready && !is_submitting">
      <h4 class="mobile-step-title">
        {{ steps[current_step].title }}
        <small class="text-muted"
          >(Step {{ current_step + 1 }}/{{ steps.length }})</small
        >
      </h4>
      <div class="seriti-container progress-bar-container">
        <div class="step-indicators">
          <div
            v-for="(step, idx) in steps"
            :key="idx"
            class="step-indicator"
            :class="{ 
              'active': idx === current_step, 
              'completed': step.is_valid && !isStepDisabled(idx),
              'disabled': isStepDisabled(idx)
            }"
            @click="!isStepDisabled(idx) && idx < current_step ? current_step = idx : null"
          >
            <div class="step-number">
              <template v-if="isStepDisabled(idx)">
                <i class="fas fa-ban"></i>
              </template>
              <template v-else>
                {{ idx + 1 }}
              </template>
            </div>
            <div class="step-title">{{ step.title }}</div>
            <div v-if="isStepDisabled(idx)" class="step-disabled-label">N/A</div>
          </div>
        </div>
      </div>
      <div class="seriti-question">
        <div v-for="(step, idx) in steps" :key="step.title">
          <transition name="card">
            <div v-if="idx === current_step">
              <component
                :is="step.component"
                :ref="`step-${idx}`"
                :getSavedSectionResponses="get_saved_section_responses"
                @validity-change="(isValid, payload) => on_validity_change(isValid, payload)"
                @previous="prev_step"
              />
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div
      v-else
      class="loading-container d-flex justify-content-center align-items-center loading-height"
    >
      <div class="text-center">
        <div class="loading-spinner mb-3">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
        <p class="loading-text">Loading...</p>
      </div>
    </div>
  </div>
</div>
